module.exports = __webpack_public_path__ + "static/media/tree2.35a23ddb.png";